import React from 'react'

export default function NotFound() {
    return (
        <div>
            <h2> Opps !!! something went wrong.</h2>
        </div>
    )
}
